import {IndexItem} from './indexItem';
import {BookItem} from './bookItem';


/**
 * Class BookItem.
 *
 * Holds common properties and behaviors to all RuleBook data items.
 */
export class BookIndexFrame {
  protected _articles: IndexItem[] = [];
  protected _pages: IndexItem[] = [];
  constructor(item: IndexItem) {
    item.children.forEach(item => this.processItem(<IndexItem> item))
  };

  protected processItem(item: IndexItem): void {
    switch(item.type) {
      case 'pag':
        this._pages.push(item);
        break;
      case 'txt':
        this._articles.push(item);
        break;
    }
  }

  public get articles(): IndexItem[] {
    return this._articles;
  }

  public get pages(): IndexItem[] {
    return this._pages;
  }
}
